<script setup lang="ts">
import type { UserProperties } from '@/pages/erp/du/user/db/du-user-types'
import UserManagementDrawer from './du-user-management-drawer.vue'

import ExportDialog from './du-management-export-dialog.vue'

import moment from 'moment'
import {convertToROCDate} from "@/utils/deUtil";

definePage({
  meta: {
    action: 'manage',
    subject: 'DUUSER',
  },
})

const groupId = ref()
const groupDesc = ref()
const groupType = ref('R')

// propsData
const propsData = ref<UserProperties>({} as UserProperties)

// 匯入&同步btn
const remitBtn = ref(false)

// drawer
const isDataDrawerVisible = ref(false)
const isNewForDrawer = ref(false)


// switch
const switchValue = ref(false)
const switchLabels = ref(['全部顯示','全部顯示'])

// select
const unitItems=[
    {'name':"國訓中心",'id':'01'},
    {'name':"羽球協會",'id':'02'},
]

// API-GET
const compNo= ref(useStorage('compNo', 'nstc').value)
const currentPage = ref(1)
const size = ref(10)
const depNo = ref()
const sortOrder = ref()
const orderByCol = ref()
const userNo = ref()
const cname =ref()
const postNo = ref()
// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// Data table options
const grid1Headers= ref([
  { title: '#', key: 'id' },
  { title: '帳號', key: 'userNo' },
  { title: '姓名', key: 'cname' },
  { title: '單位名稱', key: 'depNo' },
  { title: '職稱', key: 'postNo' },
  { title: '電子郵件', key: 'email' },
  { title: '電話', key: 'phone1' },
  { title: '狀態', key: 'status'},
  { title: '有效期限', key: 'validDate'},
  { title: '操作', key: 'actions', sortable: false},
])

// exportData
const exportData = ref()
const isExportDialogVisible = ref(false)

// 引用 file input
const fileInput = ref(null);

const openRemitBtn = () => {
  fileInput.value.click();
}
// 處理文件選擇事件
const handleFileChange = async (event) => {
  const file = event.target.files[0];

  if (!file) {
    return;
  }

  // 確認是 JSON 文件
  if (file.type !== 'application/json') {
    alert('請選擇一個 JSON 檔案');
    return;
  }

  try {
    // 讀取文件內容
    const fileContent = await file.text();
    // 將文件上傳到伺服器
    await uploadFileToServer(fileContent);
  } catch (error) {
    console.error('檔案上傳失敗', error);
  }
};

// 上傳文件至伺服器
const uploadFileToServer = async (fileContent) => {
  $api('/du/user/user/import', {
    method: 'POST',
    body: fileContent,
  }).then(() => {
    $swal({
      position: 'top-end',
      icon: 'success',
      title: '匯入完成',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
    fileInput.value.value = '';
    fetchUsers()
  }).catch((err) => {
    fileInput.value.value = '';
  })
};

const openUserManagementDrawer =(item: UserProperties , isNew: boolean) => {
  isDataDrawerVisible.value = true
  isNewForDrawer.value = isNew
  propsData.value = item || {} as UserProperties
}
const depNoValue = ref()
const postNoValue = ref()

const validDate_S = ref(moment().format('YYYYMMDD'))

watch(switchValue, (val) => {
  console.log('switch: ', val)
  if (val) {
    validDate_S.value = '00000000'
  } else {
    validDate_S.value = moment().format('YYYYMMDD')
  }
})

// 👉 Fetching users
const { data: usersData, execute: fetchUsers } = await useApi<any>(createUrl('/du/user/user/searchUser', {
  query: {
    compNo,
    userNo,
    cname,
    depNo_EQ:depNoValue,
    validDate_S,
    page,
    size,
    orderByCol,
    sortOrder,
    postNo_EQ:postNoValue,
    status,
  },
}))
const datas = computed((): UserProperties[] => usersData?usersData.value.data.userPage.content:[])
const totalDatas = computed(() => usersData?usersData.value.data.userPage.totalElements:0)


// const addNewData = (userData: UserProperties) =>{
//   console.log(userData)
// }
// 👉 Add new data
const addNewData = async (userData: UserProperties) => {
  await $api('/du/user/user/createUser', {
    method: 'POST',
    body: { user: userData },
  }).then((response) => {
    console.log('Response:', response)
    if (response.status=="409"){
      $swal({
        position: 'top-end',
        icon: 'error',
        title: '新增失敗',
        text: response.message,
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }else{
      $swal({
        position: 'top-end',
        icon: 'success',
        title: '新增成功',
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }
  })

  // refetch data
  fetchUsers()
}

const updateData = async (userData: UserProperties) => {
  console.log(userData)
  await $api('/du/user/user/updateUser', {
    method: 'PUT',
    body: { user: userData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchUsers()
}

// 👉 重設密碼
const changePwd = async (userData: UserProperties) => {
  $swal({
    title: `確定要重設 ${userData.cname} 密碼?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      $api(`/du/user/password/reset`, {
        method: 'POST',
        body: {
          pwd:[
            {
              userNo: userData.userNo,
              compId: compNo.value,
            }
          ]
        }
      }).then(() => {
        $swal({
          position: 'top-end',
          title: "重設成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchUsers()
      })
      .catch((error) => {
        // Handle the error
        $swal({
          title: "重設失敗",
          position: 'top-end',
          text: error.message || "請稍後再試",
          icon: "error"
        });
      });
    }
  });

}

// 👉 解鎖
const unlock = async (userData: UserProperties) => {
  $swal({
    title: `確定要解鎖 ${userData.cname} ?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      $api(`/du/user/user/unlockUser`, {
        method: 'POST',
        body: {
          compNo: compNo.value,
          userNo: toCode(userData.userNo),
        }
      })
      .then(() => {
        $swal({
          position: 'top-end',
          title: "解鎖成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchUsers();
      })
      .catch((error) => {
        // Handle the error
        $swal({
          title: "解鎖失敗",
          text: error.message || "請稍後再試",
          icon: "error",
          position: 'top-end',
        });
      });
    }
  });
}

// 👉 Delete data
const deleteData = async (userData: UserProperties) => {
  const { compNo,userNo } = userData
  $swal({
    title: `確定要刪除 ${userData.userNo} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      $api(`/du/user/user/deleteUser`, {
        method: 'DELETE',
        query: {
          compNo,userNo
        }
      }).then(() => {
        $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchUsers()
      })
    }
  });

}

const exportBtn =  () => {
  isExportDialogVisible.value=true
  // exportUsers()
}

watch(depNo, () =>{
  depNoValue.value = toCode(depNo.value)
  fetchUsers()
})
watch(postNo, () =>{
  postNoValue.value = toCode(postNo.value)
  fetchUsers()
})

const isActive = (status: string, validDate: string) => {
  if (typeof status == 'string') {
    return toCode(status) == 'A'
  }

  return validDate >= moment().format('YYYYMMDD')

}

const isLoaderDialogVisible = ref(false)
const isSyncDialogVisible = ref(false)

const syncSelected = ref(['member', 'unit', 'job'])

const onSync = async () => {
  isLoaderDialogVisible.value = true
  isSyncDialogVisible.value = false
  await $api('/orp/api/sync', {
    method: 'POST',
    body: syncSelected.value,
  }).then((resp) => {
    console.log('sync resp ', resp)
    if (resp.status == 0) {
      $swal({
        icon: 'warning',
        title: '同步失敗',
        text: `${resp.message}`,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "確定"
      })
    } else {
      $swal({
        title: '同步完成',
        html: `
        <p >新增人員資料 ${resp.createMembers ? resp.createMembers : '0'} 筆</p>
        <p >更新人員資料 ${resp.existsMembers ? resp.existsMembers : '0'} 筆</p>
        <p >新增單位資料 ${resp.createDepts ? resp.createDepts : '0'} 筆</p>
        <p >更新單位資料 ${resp.existsDepts ? resp.existsDepts : '0'} 筆</p>
        <p >新增職稱資料 ${resp.createPosts ? resp.createPosts : '0'} 筆</p>
        <p >更新職稱資料 ${resp.existsPosts ? resp.existsPosts : '0'} 筆</p>
      `,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "確定"
      })
    }

    isLoaderDialogVisible.value = false
  })

  // refetch data
  fetchUsers()
}

const onCancle = () => {
  isSyncDialogVisible.value = false
}

const syncBtn = () => {
  isSyncDialogVisible.value = true
}
</script>
<template>
<div>
  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>
    <VCardText >
      <VRow class="py-4">
        <VCol cols="12" sm="3" class="px-4">
          <AppInput
            v-model="depNo"
            type="picker"
            item-title="label"
            item-value="value"
            placeholder="請選擇單位"
            :picker="duDepartmentPicker"
            :disabled="false"
            :queryAll="false"
          />

        </VCol>
        <VCol cols="12" sm="3" class="px-4">
          <AppInput
            v-model="postNo"
            type="picker"
            item-title="label"
            item-value="value"
            placeholder="請輸入職稱代碼"
            :picker="duPositionPicker"
            :disabled="false"
            :queryAll="false"
          />
        </VCol>
        <VCol cols="12" sm="3" class="px-4">
          <AppTextField
            class=""
            v-model="cname"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入姓名"
          />
        </VCol>
        <VCol cols="12" sm="3" class="px-4">
          <AppTextField
            class=""
            v-model="userNo"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入帳號"
          />
        </VCol>
      </VRow>
      <VRow class="border-t-sm">
        <VCol cols="12" sm="3" >
            <div class="d-flex" >
              <div class="d-flex align-center px-1">
                {{switchValue ? switchLabels[1] : switchLabels[0]}}
              </div>
              <VSwitch
                v-model="switchValue"
              />
            </div>
        </VCol>
        <VCol cols="12" sm="9" >
          <div class="d-flex justify-end">
            <VBtn
              color="info"
              variant="tonal"
              prepend-icon="tabler-refresh"
              @click="syncBtn"
            >
              同步
            </VBtn>
            <VBtn
              class="ml-4"
              color="secondary"
              variant="outlined"
              prepend-icon="tabler-upload"
              @click="openRemitBtn"
            >
              匯入
            </VBtn>
            <!-- 隱藏的文件選擇器 -->
            <input
              type="file"
              ref="fileInput"
              accept="application/json"
              style="display: none"
              @change="handleFileChange"
            />
            <VBtn
              class="ml-4"
              color="primary"
              variant="tonal"
              prepend-icon="tabler-download"
              @click="exportBtn"
            >
              匯出
            </VBtn>
            <VBtn
              class="ml-4"
              prepend-icon="tabler-plus"
              @click="openUserManagementDrawer({} as UserProperties , true)"
            >
              新增
            </VBtn>
          </div>
        </VCol>
      </VRow>
    </VCardText>
    <VDataTableServer
      v-model:items-per-page="size"
      v-model:page="currentPage"
      :items="datas"
      :items-length="totalDatas"
      :headers="grid1Headers"
      class="text-no-wrap border-t-sm rounded-0"
      no-data-text="尚無資料"
    >

      <template #item.id="{ item, index }">
        <div class="text-body-1 text-high-emphasis">
          {{ index + 1 }}
        </div>
      </template>
      <template #item.depNo="{ item }">
        <div class="text-body-1 text-high-emphasis text-capitalize">
          <div class="text-body-1 text-high-emphasis">
            {{ toText(item.depNo) }}
          </div>
        </div>
      </template>
      <template #item.postNo="{ item }">
        <div class="text-body-1 text-high-emphasis">
          {{ toText(item.postNo) }}
        </div>
      </template>

      <template #item.userNo="{ item }">
        <div class="text-body-1 text-high-emphasis">
          {{ item.userNo }}
        </div>
      </template>

      <template #item.status="{ item }">
        <VChip
          :label="false"
          :color="isActive(item.status, item.validDate) ? 'success' : 'error'"
          style="height:30px;width:30px"
          class="px-1"
        >
          <VIcon
            start
            :icon="isActive(item.status, item.validDate) ? 'tabler-check' : 'tabler-x'"
          />
        </VChip>
      </template>
      <template #item.validDate="{ item }">
        <div class="text-body-1 text-high-emphasis">
          {{ convertToROCDate(item.validDate, '-') }}
        </div>
      </template>
      <!-- Actions -->
      <template #item.actions="{ item }">
        <VBtn
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="openUserManagementDrawer(item , false)"
        >
          編輯
        </VBtn>
        <VBtn
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="changePwd(item)"
        >
          重設密碼
        </VBtn>
        <VBtn
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="deleteData(item)"
        >
          刪除
        </VBtn>
        <VBtn
          v-if="item.userStatus == 'F'"
          variant="outlined"
          density="compact"
          style="margin-right: 10px;"
          @click="unlock(item)"
        >
          解鎖
        </VBtn>



      </template>
      <!-- pagination -->
      <template #bottom>
        <TablePagination
          v-model:page="currentPage"
          v-model:size="size"
          :items-per-page="size"
          :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>

  </VCard>

  <UserManagementDrawer
    v-model:isDrawerOpen="isDataDrawerVisible"
    :is-new="isNewForDrawer"
    :props-data="propsData"
    @create-data="addNewData"
    @update-data="updateData"
  />
  <ExportDialog
  v-model:isDialogVisible="isExportDialogVisible"
  :validDate="validDate_S"
  export-api="/du/user/user/exportUsers"
  />
  <VDialog
    v-model="isSyncDialogVisible"
    max-width="600"
  >
    <!-- Dialog Content -->
    <VCard title="選擇同步資料">
      <VCardText class="pt-3">
        <div class="demo-space-x">
          <VCheckbox
            v-model="syncSelected"
            label="人員"
            value="member"
          />

          <VCheckbox
            v-model="syncSelected"
            label="單位"
            value="unit"
          />

          <VCheckbox
            v-model="syncSelected"
            label="職稱"
            value="job"
          />
        </div>
      </VCardText>
      <VCardText class="d-flex justify-end flex-wrap gap-3">
        <VBtn
          color="secondary"
          variant="outlined"
          @click="onCancle"
        >
          取消
        </VBtn>

        <VBtn
          color="primary"
          variant="tonal"
          @click="onSync"
        >
          確定
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>
  <VDialog
    v-model="isLoaderDialogVisible"
    width="300"
    persistent
  >
    <VCard
      color="primary"
      width="300"
    >
      <VCardText class="pt-3">
        同步中請稍後...
        <VProgressLinear
          indeterminate
          bg-color="rgba(var(--v-theme-surface), 0.1)"
          :height="8"
          class="mb-0 mt-4"
        />
      </VCardText>
    </VCard>
  </VDialog>
</div>
</template>
